import React from "react";
import { shallowEqual } from "react-redux";
import { useCarConfigSelector } from "../../../../../redux/store";
import InsurancePrice from "../../price/InsurancePrice";
import { getInsuranceQuoteIdFromStorage, getSessionStorageParams } from "../../../../../utils/sessionStorage";
import { useTabsContext } from "../SummaryTabsContext";
import { CarConfigLabel, useCarConfigLabel, useCarConfigOptionalLabel } from "../../../../../utils/labelUtils";
import Button from "../../../../../../shared-components/css-modules/lexus/atoms/Button";
import styles from "../Summary.module.scss";
import useAphModal from "../../../../../hooks/useAphModal";
import { MODAL_INSURANCE_CALCULATOR, MODAL_INSURANCE_DISCLAIMER } from "../../../../../utils/modalConstants";
import { trackOrderOverviewInsuranceInfo } from "../../../../../utils/tracking";
import type { SummaryTabPropsTypes } from "../../../../../hooks/useAphSummaryTabs";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";

const SummaryInsurance: React.FC<SummaryTabPropsTypes> = (props) => {
    const { tabId, tab } = props;
    const modelId = useCarConfigSelector((state) => state.car.model.id);
    const sessionStorageParams = useCarConfigSelector(getSessionStorageParams, shallowEqual);
    const insuranceQuoteId = getInsuranceQuoteIdFromStorage(sessionStorageParams, modelId);
    const insurance = useCarConfigSelector((state) => state.insurance);
    const disclaimerText = useCarConfigLabel("carConfigInsuranceTabPriceDisclaimer");
    const hasDisclaimer = !!insurance.info.disclaimer?.table || insurance.info.disclaimer?.value;

    const tabsContext = useTabsContext();
    const { showModalHelper } = useAphModal();

    const carConfigInsuranceInfo = useCarConfigOptionalLabel("carConfigInsuranceInfo");

    return (
        <section
            className={styles["tab-panel"]}
            role="tabpanel"
            id={tabId}
            aria-labelledby={tab}
            hidden={tabsContext.openTab !== "insurance"}
        >
            <div className={styles.insurance}>
                <ul role="list" className={styles["config-sublist"]}>
                    <li className={styles["config-subitem"]}>
                        <div className={styles["config-subitem-title"]}>
                            <CarConfigLabel label="carConfigInsuranceTitle" />
                        </div>
                        <div className={styles["config-subitem-price"]}>
                            <Button
                                variant="apheleia-text"
                                onClick={() => showModalHelper(MODAL_INSURANCE_CALCULATOR, {})}
                            >
                                {!insuranceQuoteId ? (
                                    <div className={styles["open-insurance-calculator"]}>
                                        <Icon variant="calculator" sizing="sm" />
                                        <CarConfigLabel label="carConfigInsuranceCta" />
                                    </div>
                                ) : (
                                    <CarConfigLabel label="carConfigInsuranceEditCta" />
                                )}
                            </Button>
                        </div>
                    </li>

                    {insuranceQuoteId ? (
                        <li className={styles["config-subitem-small"]}>
                            <div className={styles["config-subitem-title"]}>{insurance.name}</div>
                            <div className={styles["config-subitem-price"]}>
                                <InsurancePrice />
                            </div>
                        </li>
                    ) : (
                        carConfigInsuranceInfo && (
                            <Text variant="apheleia-body" tag="p" className={styles["finance-insurance-info"]}>
                                {carConfigInsuranceInfo}
                            </Text>
                        )
                    )}
                </ul>

                {hasDisclaimer && (
                    <Button
                        variant="apheleia-text"
                        onClick={() => {
                            trackOrderOverviewInsuranceInfo();
                            showModalHelper(MODAL_INSURANCE_DISCLAIMER, {});
                        }}
                    >
                        <CarConfigLabel label="carConfigInsuranceTabMoreInfo" />
                    </Button>
                )}

                <div className={styles.disclaimer}>
                    <p dangerouslySetInnerHTML={{ __html: disclaimerText }} />
                </div>
            </div>
        </section>
    );
};

export default SummaryInsurance;
